export const createInitialValues = () => ({
  input: '',
});